import { Component, OnInit,ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ExcelService } from '../service/tableUtility.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { savedList } from '../models/savedList';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-saved-list-management',
  templateUrl: './saved-list-management.component.html',
  styleUrls: ['./saved-list-management.component.css']
})
export class SavedListManagementComponent implements OnInit {

  showFilter:boolean=false
  userSessionData:any;
  userDetails:any;
  read:any;
  write:any;
  delete:any;
  export:any
  dataSource: any;
  tableData: [] = [];
  showCustomisedSearch:boolean=false;
  searchValue:any;
  filterValueSelected:any;
  show:boolean=false;
  savedListAddObj:savedList;
  savedListUpdateObj:savedList
  currentInventoryList:any;
  userAccountsList:any
  theDate:any
  minDate = new Date();

  displayedColumns = [ 'AccountEmailId','_id', 'ProductId', 'ProductName','Description','RequiredQuantity','StockUnit','PlannedPurchasedDate','vendor','Price','DateOfCreation','AddedByUserId','Actions']
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("savedList") form: any;
  @ViewChild("savedListUpdate", {static: true}) formUpdate: any;
  constructor(private cs:CucurachaAdminService,private excelService: ExcelService,private toastr: ToastrManager) { 
    this.savedListAddObj=new savedList()
    this.savedListUpdateObj=new savedList()

  }  
  
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  exportTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'SavedListManagement');
    this.cs.exportLogAdd(this.userDetails.emailId, 'SavedListManagement').subscribe((data) => {
    })
  }
  getAllUserAccountsByStatus() {
    this.cs.getAllAccountsByStatus().subscribe((data) => {
      this.userAccountsList = data
    })
  }
  
  getByCurrentInventoryStatusandEmailID(id:any){
    this.cs.getByCurrentInventoryStatusandEmailID(id).subscribe((data) => {
      this.currentInventoryList=data
    })
  }
  addSaveList() {

    if (this.show == false) {
      this.show = true
    }
    else {

      this.show = false
    }
  }
  filter() {
    this.getAllSavedListManagement()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""



    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""




    }
  }
  saveSavedList(){
    this.cs.saveSavedList(this.savedListAddObj).subscribe((data) => {
      if(data.result ){
        this.getAllSavedListManagement();
        this.toastr.successToastr(data.message);
        this.form.reset();
        
        }
       else if(data.err){
        this.toastr.warningToastr(data.message);
  
       }
        else{
          this.toastr.errorToastr(data.message);
  
        }
    })
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllSavedListManagement();

  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForSavedList(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAllSavedListManagement()
    }
  }
  getAllSavedListManagement(){
    this.cs.getAllSavedListManagement().subscribe((data) => {
      console.log(data)
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })

  }
  getBySavedListId(id:any){
    this.cs.getBySavedListId(id).subscribe((data) => {
      console.log(data[0])
      this.savedListUpdateObj._id = data[0]._id;
      this.savedListUpdateObj.accountId = data[0].accountId;
      this.savedListUpdateObj.productId = data[0].productId;
      this.savedListUpdateObj.requiredQuantity = data[0].requiredQuantity;
      this.theDate = data[0].plannedPurchasedate;
    })
  }
  updateSavedList(){
    this.savedListUpdateObj.plannedPurchasedate=this.theDate
      this.cs.updateSavedList(this.savedListUpdateObj).subscribe((data) => {
        if (data.result) {
          this.getAllSavedListManagement();
          this.toastr.infoToastr(data.message);
          this.formUpdate.reset();
  
        }
        else if (data.err) {
          this.toastr.warningToastr(data.message);
  
        }
        else {
          this.toastr.errorToastr(data.message);
  
        }
      })
    }
  deleteSavedList(id:any){
    this.cs.deleteSavedList(id).subscribe((data) => {
      this.getAllSavedListManagement()
      this.toastr.warningToastr("Data  Deleted");


    })
  }
  ngOnInit(): void {
  
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
      this.read = (this.userDetails.roledetails[0].components[0].component_name[0][0].savedList_management.permissions[0].read);
      this.write = (this.userDetails.roledetails[0].components[0].component_name[0][0].savedList_management.permissions[0].write)
      this.delete = (this.userDetails.roledetails[0].components[0].component_name[0][0].savedList_management.permissions[0].delete)
      this.export = (this.userDetails.roledetails[0].components[0].component_name[0][0].savedList_management.permissions[0].export)

    })
    this.getAllSavedListManagement();
    this.getAllUserAccountsByStatus();
  }



}
